<template>
  <div class="east-block-product-detail">
    <div class="east-block-product-detail__header">
      <div class="east-block-product-detail__header__text">
        <stuff-to-eat-info-small-card
           slot="left"
          :reactive="false"
          :details="contentDetails">
        </stuff-to-eat-info-small-card>
      </div>
    </div>
    <div class="east-block-product-detail__body">
      <div class="east-block-product-detail__body__content">
        <div class="body-content-tab" :class="{ 'is-active': activeTab === 'nutrition_facts' }">
          <nutrition-facts
             v-if="StuffToEatNutritionFacts.ready"
            :mode="mode"
            :productNutritionFacts="StuffToEatNutritionFacts.data">
          </nutrition-facts>
        </div>
        <div
           v-if="StuffToEatContents"
           class="body-content-tab is-no-right-padding"
          :class="{ 'is-active': activeTab === 'ingredients' }">
          <div class="ingredients-list">
            <template v-if="_isEmpty(StuffToEatContents.data)">
              <p class="no-ingredients">
                {{ $t('label.no_ingredients') }}
              </p>
            </template>
            <template v-else>
              <p class="ttl">{{ $t('label.ingredients') }}</p>
              <ul>
                <li v-for="item in StuffToEatContents.data">
                  <span class="weight_gr">{{ item.weight_gr | number-format(2) }}g</span>
                  (<span v-if="item.ContentServingSize.code === 'total_ingredients_quantity'" class="content-quantity__serving-size">{{ item.ContentServingSize.title || item.ContentServingSize.description }}</span>
                  <span v-else-if="item.ContentServingSize.symbol !== 'g'" class="content-quantity__serving-size">{{ item.amount | number-format(2) }} {{ item.ContentServingSize.title || item.ContentServingSize.description }}</span>)
                  - {{ item.Content.name }}
                </li>
              </ul>
            </template>
          </div>
        </div>
        <div class="east-block-product-detail__body__bottom">
          <template v-for="tab in tabs">
            <button
               class="button button--more-less is-small theme-gray"
              :class="{ 'is-active': activeTab === tab }"
              @click="changeTab(tab)">
              {{ $t(`label.${tab}`) }}
            </button>

          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { splitByComma } from 'utils';

import { includes } from 'lodash';
import { STUFF_TO_EAT_KEYS } from 'constants/types';

import NutritionFacts from 'components/ui/nutrition-information/nutrition-facts';
import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';

export default {
  name: 'cmpt-east-block-product-detail',
  props: {
    contentID: {
      required: true,
    },
    contentType: {
      required: true,
    },
    servingSizeID: {
      required: false,
    },
    programID: {
      required: false,
    },
    amount: {
      required: false,
      default: 1,
    },
    mode: {
      required: false,
      default: 'quantity',
    },
    contentDetails: {
      required: true,
      default: null,
    },
    productType: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      activeTab: null,
      tabs: ['nutrition_facts'],
      showNutritionFacts: false,
      showIngredients: false,
      hasIngredientsList: [
        STUFF_TO_EAT_KEYS.dish,
        STUFF_TO_EAT_KEYS.drink,
      ],
    };
  },
  components: {
    NutritionFacts,
    StuffToEatInfoSmallCard,
  },
  computed: {
    title() {
      return splitByComma(this.contentDetails.name, 'title');
    },
    subTitle() {
      return splitByComma(this.contentDetails.name, 'subtitle');
    },
    StuffToEatContents() {
      return this.$store.getters.StuffToEatContents(this.contentID);
    },
    StuffToEatNutritionFacts() {
      return this.$store.getters.StuffToEatNutritionFacts(this.contentID);
    },
  },
  methods: {
    changeTab(tab) {
      if (this.activeTab === tab) this.activeTab = null;
      else this.activeTab = tab;
    },
    toggleShowNutritionFacts() {
      this.showNutritionFacts = !this.showNutritionFacts;
    },
    toggleShowIngredients() {
      this.showIngredients = !this.showIngredients;
    },
    fetchNutritionFacts() {
      if (this.amount > 0) {
        this.$store.dispatch('GetStuffToEatNutritionFacts', {
          id: this.contentID,
          type: this.contentType,
          servingSizeID: this.servingSizeID,
          programID: this.programID,
          amount: this.amount,
        });
      }
    },
    fetchIngredients() {
      this.$store.dispatch('GetStuffToEatContents', { id: this.contentID, type: this.contentType });
    },
  },
  created() {
    this.fetchNutritionFacts();
    if (this.contentType && includes(this.hasIngredientsList, this.contentType)) {
      this.fetchIngredients();
      this.tabs.push('ingredients');
    }
  },
  watch: {
    servingSizeID(newVal, oldVal) {
      const changed = Number(newVal) !== Number(oldVal);
      if (newVal && changed) this.fetchNutritionFacts();
    },
    amount(newVal, oldVal) {
      const changed = Number(newVal) !== Number(oldVal);
      if (newVal && changed) this.fetchNutritionFacts();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  .east-block-product-detail {
    display: flex;
    flex-grow: 1;
    position: relative;
    align-self: stretch;
    // margin-bottom: 1em;
    flex-direction: column;
    .east-block-product-detail__header {
      display: flex;
      align-self: stretch;
      padding: 0.75em 0.75em;
      background-color: $nutrition-facts-orange-light-bg;
      .east-block-product-detail__header__text {
        flex-grow: 1;
        align-self: stretch;
        display: flex;
        flex-direction: column;
        .east-block-product-detail__header__title {
          font-weight: 600;
          font-size: 1.1rem;
        }
        .east-block-product-detail__header__subtitle {
          line-height: 1.15;
        }
      }
    }
    .east-block-product-detail__body {
      flex-grow: 1;
      display: flex;
      position: relative;
      .east-block-product-detail__body__content {
        width: 100%;
        flex-grow: 1;
        display: flex;
        align-self: stretch;
        flex-direction: column;
        transition: all 0.5s linear;
        justify-content: space-between;
        .east-block-product-detail__body__bottom {
          display: flex;
          align-self: stretch;
          justify-content: center;
          border-top: 2px solid $nutrition-facts-orange-light-border;
          button {
            margin-right: 0.5em;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }

  .body-content-tab {
    opacity: 0;
    display: none;
    padding: 0.5em 0.75em;
    transition-property: all;
    transition-duration: 200ms;
    background-color: $nutrition-facts-orange-light-bg;
    border-top: 1px solid $nutrition-facts-orange-light-border;
    &.is-active {
      opacity: 1;
      display: block;
    }
    &.is-no-right-padding {
      padding-right: 0;
    }
  }

  .ingredients-list {
    .ttl {
      font-weight: 600;
      font-size: 1rem;
      line-height: 1.5em;
    }
    .no_ingredients {
      font-size: 1rem;
      line-height: 1.5em;
    }
    ul {
      > li {
        padding: 0.25em 0;
        border-top: 1px solid $gray-lighter;
        font-size: 0.9rem;
        &:first-child {
          border-top: none;
        }
        .weight_gr {
          font-weight: 500;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/entity/cmpt-east-block-product-detail.vue